import clsx from "clsx";
import { ReactNode, Suspense } from "react";

import { DefaultSkeleton } from "./DefaultSkeleton";

type SlideProps = {
    children: ReactNode;
    shouldPreload: boolean;
    className?: string;
    fallback?: ReactNode;
};

export function Slide({ children, shouldPreload, className, fallback }: SlideProps) {
    const displayed_fallback = fallback || <DefaultSkeleton />;

    return (
        <Suspense fallback={displayed_fallback}>
            {shouldPreload ? <div className={clsx(className, "overflow-hidden")}>{children}</div> : displayed_fallback}
        </Suspense>
    );
}
